import * as grpcWeb from "grpc-web";

import { HttpStatusCode } from "@/api/types";
import { ExGetterTree } from "vuex";
import { State, Getters } from "./types";

const getters: ExGetterTree<State, Getters> = {
  hasNotFoundError(state) {
    return (
      state.apiError.code === HttpStatusCode.NotFound ||
      state.grpcError.code === grpcWeb.StatusCode.NOT_FOUND
    );
  },
  hasForbiddenError(state) {
    return (
      state.apiError.code === HttpStatusCode.Forbidden ||
      state.grpcError.code === grpcWeb.StatusCode.PERMISSION_DENIED
    );
  },
  hasUnagreedTermsError(state) {
    return state.apiError.message === "unagreedTerms";
  }
};

export default getters;
